module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAL5JREFUSEtjZKAxYKSx+QyjFhAM4cERRLNnz3ZgZGRs/vnzp2d2dvYXgs5GUkC0D+bOndv///9/E1ItIdoCkKPIsYQkC8ixhGQLSLWELAtIsYRsC+bMmWPNwMCw5c+fP64ZGRlncKUssiyAGr7m79+/oenp6UfwJVuSLSDFcJDFJFlAquEkWUCO4URbMGfOHB0GBobdxIQ5enwQFURTp07lYWdnV0hJSblCSjlEtA9INRRZPVE+GLWAkhAgqBcAIm9zGbaH4kIAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/housework/right.png
// module id = K0Ve
// module chunks = 5